import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AgGridAtom } from "../../../components/atoms/atom";
import TableSkeleton from "../../../components/atoms/table-skeleton/TableSkeleton";
import { useListProjectsMemberSummaryQuery } from "../../../store/services/adminProjects";
import { showToast } from "../../../utils/method";
import "./projects-overview.scss";

function ProjectsOverviewAdminPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const { data, isLoading, isFetching, isError, error } =
		useListProjectsMemberSummaryQuery();

	const rows = useMemo(() => data?.items ?? [], [data?.items]);

	useEffect(() => {
		if (isError) {
			showToast(error?.data?.message || t("errors.general"), {
				type: "error",
			});
		}
	}, [isError, error, t]);

	const columnDefs = useMemo(
		() => [
			{
				field: "name",
				headerName: t("projects.name"),
				flex: 1,
				minWidth: 200,
			},
			{
				field: "memberCount",
				headerName: t("admin.projects-overview.member-count"),
				maxWidth: 140,
				type: "numericColumn",
			},
			{
				field: "adminCount",
				headerName: t("admin.projects-overview.admin-count"),
				maxWidth: 140,
				type: "numericColumn",
			},
		],
		[t],
	);

	const onRowClicked = useCallback(
		(event) => {
			const projectId = event?.data?.id;
			if (projectId) {
				navigate(`/projects/${projectId}/members`);
			}
		},
		[navigate],
	);

	const loading = isLoading || isFetching;

	return (
		<div className="admin-page admin-projects-overview">
			<h1 className="admin-page__title">
				{t("admin.projects-overview.title")}
			</h1>
			<div className="page-container">
				<div className="flex-grow-1 ag-grid-parent">
					{loading && rows.length === 0 ? (
						<TableSkeleton />
					) : (
						<AgGridAtom
							rowData={rows}
							columnDefs={columnDefs}
							defaultColDef={{
								sortable: true,
								filter: true,
							}}
							onRowClicked={onRowClicked}
							getRowClass={() =>
								"admin-projects-overview__row--clickable"
							}
							overlayNoRowsTemplate={`<span class="ag-overlay-no-rows-center">${t("projects.no-data")}</span>`}
							getRowId={(params) => params.data.id}
						/>
					)}
				</div>
			</div>
		</div>
	);
}

export default ProjectsOverviewAdminPage;
